/**
 * Created on 25/8/19.
 */
export default {
    headerRow: ['% of Sq Ft', 'Start', 'End',  'Annual Rent', 'PSF', 'Escalation Date', 'Escalation Amount', 'Options', 'Lease Type'],
    rows: {'no-row': {valueCells: []}}
}